import './lorettas/style';
import FormStructure from './lorettas/form_structure';

export default FormStructure;